var _rect, _line, _circle, _rect2, _rect3, _rect4, _rect5, _text, _text2, _text3, _text4, _rect6, _text5, _rect7, _rect8, _rect9, _rect10, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _polygon, _g, _text6, _text7, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClubRace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0f1923",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1a2a3a",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f7b731",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f5a623",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "green",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#27ae60",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1e8449",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "trackGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2c3e50",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#34495e",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2c3e50",
      stopOpacity: 0.6
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "url(#bg)",
    rx: 12
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 80,
    x2: 200,
    y2: 320,
    stroke: "#ffffff",
    strokeOpacity: 0.05,
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 60,
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.05,
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 130,
    width: 280,
    height: 28,
    rx: 4,
    fill: "url(#trackGrad)",
    opacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 168,
    width: 280,
    height: 28,
    rx: 4,
    fill: "url(#trackGrad)",
    opacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 206,
    width: 280,
    height: 28,
    rx: 4,
    fill: "url(#trackGrad)",
    opacity: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 244,
    width: 280,
    height: 28,
    rx: 4,
    fill: "url(#trackGrad)",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 149,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#ffffff",
    opacity: 0.4,
    textAnchor: "end"
  }, "P1")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 187,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#ffffff",
    opacity: 0.4,
    textAnchor: "end"
  }, "P2")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 225,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#ffffff",
    opacity: 0.4,
    textAnchor: "end"
  }, "P3")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 263,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#ffffff",
    opacity: 0.4,
    textAnchor: "end"
  }, "P4")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 125,
    width: 4,
    height: 152,
    fill: "#ffffff",
    opacity: 0.3
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 312,
    y: 122,
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    fill: "#ffffff",
    opacity: 0.3,
    textAnchor: "start"
  }, "META")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 136,
    width: 220,
    height: 16,
    rx: 8,
    fill: "url(#gold)",
    opacity: 0.9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 174,
    width: 170,
    height: 16,
    rx: 8,
    fill: "#3498db",
    opacity: 0.7
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 212,
    width: 190,
    height: 16,
    rx: 8,
    fill: "#e74c3c",
    opacity: 0.7
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 250,
    width: 140,
    height: 16,
    rx: 8,
    fill: "#9b59b6",
    opacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 285,
    cy: 144,
    r: 8,
    fill: "#f7b731",
    stroke: "#fff",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 235,
    cy: 182,
    r: 8,
    fill: "#3498db",
    stroke: "#fff",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 220,
    r: 8,
    fill: "#e74c3c",
    stroke: "#fff",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 258,
    r: 8,
    fill: "#9b59b6",
    stroke: "#fff",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 80,
    r: 22,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5,
    opacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 58 L200 62 M200 98 L200 102 M178 80 L182 80 M218 80 L222 80",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    opacity: 0.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "200,66 206,73 204,81 196,81 194,73",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    opacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15,-15 L-15,0 C-15,12 -5,18 0,20 C5,18 15,12 15,0 L15,-15 Z",
    fill: "url(#gold)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: 20,
    width: 10,
    height: 6,
    rx: 1,
    fill: "url(#gold)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: 26,
    width: 20,
    height: 4,
    rx: 2,
    fill: "url(#gold)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15,-10 C-25,-10 -25,5 -15,5",
    fill: "none",
    stroke: "#f7b731",
    strokeWidth: 2.5,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,-10 C25,-10 25,5 15,5",
    fill: "none",
    stroke: "#f7b731",
    strokeWidth: 2.5,
    opacity: 0.7
  }))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 300,
    fontSize: 14,
    fill: "#f7b731",
    opacity: 0.5
  }, "&#9733;")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 232,
    y: 300,
    fontSize: 14,
    fill: "#f7b731",
    opacity: 0.5
  }, "&#9733;")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10,10 L40,10 L10,40",
    fill: "none",
    stroke: "#f7b731",
    strokeWidth: 2,
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M390,10 L360,10 L390,40",
    fill: "none",
    stroke: "#f7b731",
    strokeWidth: 2,
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10,390 L40,390 L10,360",
    fill: "none",
    stroke: "#f7b731",
    strokeWidth: 2,
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M390,390 L360,390 L390,360",
    fill: "none",
    stroke: "#f7b731",
    strokeWidth: 2,
    opacity: 0.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubRace);
export default __webpack_public_path__ + "static/media/club-race.4a129b0da96661295b01a4a479d2d8bd.svg";
export { ForwardRef as ReactComponent };